export default __webpack_public_path__ + "2551e0a2ae1d728a9b976637a6d73ac6.svg";